// Markers (meta.source) identifying which dashboard list triggered a guideline fetch.
// The ui/dashboard slices only react to actions carrying their own source.
export const GROUP_DASHBOARD_SOURCE = 'guidelines-dashboard-group';
export const DEALER_DASHBOARD_SOURCE = 'guidelines-dashboard-dealer';
